<template>
  <div class="main">
    <div class="main_nav">
      <DivTop />
    </div>
    <div class="main_contetn">
        <div class="left">
           <div>
              <span>设置</span>
              <div :class="active=='1'?'activeClass':''">新的消费项目的增加和配置</div>
              <div>滑雪活其他新增加消费项目未产生费用</div>
              <div>当天价格与实际价格不一致</div>
              <div>教练未被聘请，提示工作中</div>
              <div>节假日更改后，提示“缺少必要字段”</div>
              <div>套票中包含的项目未免费</div>
              <div>套餐的使用和意义</div>
              <div>售票未选择套票或自带器材</div>
              <div>售票选择错误客户类别</div>
              <div>新增消费项目或客户类别，部分客户端用户不能操作租借或销售</div>
              <div>团队售票无押金使用方法</div>
           </div>
        </div>
        <div class="right">
          <span>新的消费项目的增加和配置</span>
          <div class="right_xt">
首先确定新增加的消费项目是否为可租借器材项目，如果是销售模式的则，不用增加器材。

（1）打开系统管理的基本设置，计费单位设置，增加新项目的计费单位，如果单位已存在，则不需要添加。添加规则为时间的，格式为“物理单位/时间”，注：系统不识别“半天”、“半小时”、“全天”，需增加为“人/0.5天”或“人/4小时”、“人/0.5小时”或“人/30分钟”、“人/天”“人/2天”。

（2）打开系统管理的器材管理，器材设置，增加，器材代码为顺序依次下排，状态“有效”，新器材的总数量和剩余数量相同，不可用数量为0。剩余数量控制可选择性勾选，如果该器材不限制租借数量则填入可租借的最大数量，是否允许多次租借（即：即使限制每人只允许租借一次，在归还后依然可以再次租借出来）。条码，不用勾选。点击“应用”。

（3）打开系统管理的消费项目管理，消费项目信息设置，增加对应为计时还是计次，默认计费单位进行选择，如果为租借项目，打印选择否，销售项目，打印普通凭证。应用。
打开第二个“项目单价设置”，增加，选择对应的计费单位，回车填写对应的平日、周末、节假日的价格，应用。打开第三个“项目器材设置”，将添加的器材和箱费项目对应，点击增加，勾选器材，应用。

（4）打开系统管理的，角色用户管理，角色权限设置，将新增加的消费项目勾选，修改→应用，对应左侧的每个组都进行勾选保存。第四个器材权限，对应该器材在哪个组租借，给哪个组勾选。除雪具大厅的租借组外，财务、收银、管理员等均要分别勾选后，点击修改、保存。

注：全部设置完成，重启客户端，即可实现新增加项目，雪具大厅的也要重新登录才能看到该器材。最好不要再营业期间进行添加。 
          </div>
          <div class="imgs">
            <img src="@/assets/wxx.png" alt="">
          </div>
        </div>
    </div>
    <div class="tm">
      <div class="left_tm"></div>
      <div class="right_tm"></div>
      <img src="@/assets/tran.png" alt="">
    </div>
    <Divfooter />
  </div>
</template>
<script>
export default {
  data(){
    return{
      active:1
    }
  }
}
</script>
<style lang="less" scoped>
.main{
  width: 100%;
  background-size:100% 100% ;
  .main_nav{
    position: relative;
    background: #001E3C;
    width: 100%;
    height: 7.2rem;
  }
  .main_contetn{
      display: flex;
      .left{
        height: 100%;
        box-sizing: border-box;
        padding: 9.7rem 3rem 10rem 0;
        width: 33%;
        background: #F6F9FC;
        display: flex;
        align-items: flex-end;
        flex-direction: column;
        >div{
          width: 27rem;
          >span{
            color: #333333;
            font-size: 2rem;
            display: block;
            margin-bottom: 3rem;
          }
          div{
            color: #333333;
            font-size: 1.6rem;
            margin-bottom: 2rem;
            cursor: pointer;
            &:hover{
              color: #246DEB;
            }
          }
        }
        
      }
      .right{
        padding: 9.7rem 10rem 10rem 10rem;
        box-sizing: border-box;
        height: 100%;
        flex: 1;
        background: #FFFFFF;
        >span{
          color: #000000;
          font-size: 2rem;
        }
        .right_xt{
          color: #333333;
          font-size: 1.6rem;
          margin-top: 2rem;
        }
        .imgs{
          margin-top: 2.8rem;
          width: 31.7rem;
          height: 10.2rem;
          img{
            width: 100%;
            height: 100%;
          }
        }
      }
  }
  .tm{
    width: 100%;
    height: 36.6rem;
    position: relative;
    img{
      width: 100%;
      height: 100%;
    }
    .right_tm{
      width: 60%;
      height: 100%;
      right: 0;
      top: 0;
      background: #FFF;
      z-index: -1;
      position: absolute;
    }
    .left_tm{
      width: 33%;
      height: 100%;
      left: 0;
      top: 0;
      background: #F6F9FC;
      z-index: -1;
      position: absolute;
    }
  }
}
.activeClass{
  color: #246DEB !important;
}

</style>